import React from 'react';
import { Linkedin, Instagram, Facebook, ArrowUp } from 'lucide-react';

const companyName = "Smart Solutions Group";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-black pt-20 pb-8 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-800 to-transparent" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-900/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 pb-16 border-b border-slate-800/50">
          <div className="lg:col-span-2">
            <a href="#hero" className="inline-flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-600/80 to-amber-800/60 flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span className="text-white font-semibold text-lg tracking-tight">
                {companyName}
              </span>
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm">
              Distribuidora B2B líder em suprimentos corporativos.
              Excelência, qualidade e atendimento personalizado há mais de 10 anos.
            </p>

            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-900/50 border border-slate-800/50 flex items-center justify-center text-slate-400 hover:text-white hover:border-amber-600/30 hover:bg-slate-900 transition-all duration-300"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-900/50 border border-slate-800/50 flex items-center justify-center text-slate-400 hover:text-white hover:border-amber-600/30 hover:bg-slate-900 transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-900/50 border border-slate-800/50 flex items-center justify-center text-slate-400 hover:text-white hover:border-amber-600/30 hover:bg-slate-900 transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-slate-500 text-sm">
            © {currentYear} {companyName}. Todos os direitos reservados.
          </p>

          <button
            onClick={scrollToTop}
            className="group flex items-center gap-2 text-slate-400 hover:text-white text-sm transition-colors duration-300"
          >
            <span>Voltar ao topo</span>
            <div className="w-8 h-8 rounded-lg bg-slate-900/50 border border-slate-800/50 flex items-center justify-center group-hover:border-amber-600/30 group-hover:bg-slate-900 transition-all duration-300">
              <ArrowUp className="w-4 h-4" />
            </div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
